import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { Movie } from '@/mocks/movies';

interface MovieGridProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  linkTo?: string;
}

export default function MovieGrid({ title, subtitle, movies, linkTo }: MovieGridProps) {
  return (
    <section>
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">{title}</h2>
          {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
        {linkTo && (
          <Link
            to={linkTo}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="whitespace-nowrap text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}